// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"09148ccd","787":"97a9252f"}[chunkId] + ".chunk.js";
};